export default {
  common: {
    adminFunction: "Fonction d'administrateur",
    ecatLibrary: "e-CAT bibliothèque",
    accountManagement: "Gestion de compte",
    accountPermission: "Gestion des comptes et des permissions",
    regionManagement: "Gestion de la région",
    zoneCountryCity: "Mettre à jour zone, pays et ville",
    cityWeatherManagement: "Données météorologiques de la ville",
    weatherProfileBaseOnCity: "Mettre à jour le profil météorologique basé sur la ville",
    ecatDataManagement: "Gestion des données e-CAT",
    digitalEcatLibrary: "Bibliothèque e-CAT numérique",
    ecatLibraryEquipmentsModels: "Bibliothèque e-CAT équipements et modèles",
    cancel: "Annuler",
    save: "Enregistrer",
    permission: "Permission",
    noAccountInfo: "Aucune information de compte",

    customerFeedback: "Feedback des clients",
    viewFeedbackList: "Afficher les informations de retour de tous les clients",

    unitSetting: "Paramètre d'unité",
    globalUnitPreferences: "Préférences d'unité globales",

    usefulTools: "Outils utiles",
    efficiency: "Efficacité"
  },
  account: {
    inputUserName: "Entrer l'e-mail",
    thereAreNoMoreUsersLeft: "Il n'y a plus d'utilisateurs.",
    superAdmin: "Super Administrateur",
    global: "Mondiale",
    region: "Région",
    regional: "De la région",
    zoneCountry: "Zone/Pays",
    city: "Ville",
    segmentMegaCity: "Segment (Mega ville)",
    status: "Statut",
    activeStatus: "Active status",
    role: "Rôle",
    active: "Actif",
    inactive: "Inactif",
    fillRole: "Veuillez choisir un rôle",

    multiRegional: "Multi régional",
    multiZoneCountry: "Multi pays",
    singleZoneCountry: "Zone ou pays unique",

    otherRegions: "autres régions",
    otherZones: "autres zones"
  },
  feedback: {
    yourOpinionImportant: "Votre opinion est très importante",
    tellYourExperience: "Veuillez nous dire votre expérience utilisateur",
    detailedFeedback: "Veuillez saisir votre commentaire:",
    provideDetailedYourOpinionssuggestions: "Veuillez fournir une description détaillée de vos opinions et suggestions, Vous pouvez rouvrir cette page depuis [Mon espace] -> [Mes commentaires]",
    submitFeedback: "Soumettre des commentaires",
    localAdministrator: "soutien local",
    ifProblemsContact: "Si vous rencontrez des problèmes urgents, veuillez contacter",
    noFeedback: "Aucun commentaire",
    submissionSuccessful: "Soumission réussie",
    myFeedback: "Mes commentaires",
    thereAreNoMoreFeedbackLeft: "Il n'y a plus de commentaires."
  },
  digitalEcat: {
    publicEcatLib: "Bibliothèque e-CAT",
    myCustomized: "	Bibliothèque personnalisée",
    chillerCapacity: "Capacité du refroidisseur",
    thereNoEcatLeft: "Il ne reste plus de données e-CAT",
    capacityRange: "Portée de capacité",
    compressorType: "Type de compresseur",
    refrigerantType: "Type de réfrigérant",
    pleaseSelectOrEnter: "Rechercher un modèle ou sélectionner des critères de filtre",
    clickHereToSelectAJsonFile: "Cliquez ici pour sélectionner un fichier JSON",
    successfullyParsed: "Les modèles {modelsCount} ont été parsés avec succès",
    bearingType: "Type de roulement",
    manufacturingRegion: "Région de fabrication",
    me: "moi",
    libraryOwner: "Propriétaire de la bibliothèque",
    addSelfChillerModel: "Ajouter un modèle de chiller propre",
    capacity: "Capacité",
    designCondenserTemp: "Température du condenseur de conception",
    eCatPerformanceData: "Données de performance e-CAT",
    point4Data: "Données de 4 points",
    point10Data: "Données de 10 points",
    computerPreview: "Aperçu de la courbe de performance",
    previewChilledWaterTemp: "Aperçu de la température d'alimentation en eau refroidie",
    previewCondenserTemp: "Aperçu de la température de l'eau du condenseur",
    previewCondenserAirTemp: "Aperçu de la température d'alimentation en air du condenseur",
    compute: "Calculer",
    chillerType: "Type de chiller",
    youAreCurrentlyUsingLibrary: "Vous utilisez actuellement la bibliothèque '{selectUserEmail}' et vous n'êtes pas autorisé à la modifier ou à l'enregistrer.",

    chillerModel: "Modèle de chiller",
    modelNumber: "Numéro de modèle",
    objective: "Objectif",
    heatpumpType: "Type de pompe à chaleur",
    heatpumpFileParsed: "Fichier de pompe à chaleur analysé avec succès",
    chillerFileParsed: "Fichier de groupe frigorifique analysé avec succès",

    previewSourceWaterTemp: "Aperçu de la température de départ de l'eau de source",
    previewSourceAirTemp: "Aperçu de la température de l'air de source",
    previewHotWaterTemp: "Aperçu de la température de départ de l'eau chaude",

    deviceType: "Type d'équipement",
    addSelfHeatPumpModel: "Ajouter son propre modèle de pompe à chaleur",
    heatPumpModel: "Modèle de pompe à chaleur",
    selectEquipmentType: "Sélectionner le type d’équipement",
    createACustomChillerModel: "Créer un modèle personnalisé de groupe d’eau glacée",
    createACustomHeatPumpModel: "Créer un modèle personnalisé de pompe à chaleur"
  },
  usefulTools: {
    asseesConfig: "Évalue les avantages de la mise à niveau des ventilateurs de l'unité de distribution d'air pour les configurations d'entraînement direct.",
    clickEnter: "Cliquez pour entrer",
    integratesTools: "Cette plateforme intègre tous les outils de mise à niveau et de modernisation"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/fr.js